// GENERATED by scripts/build-i18n-version.mjs from src/assets/i18n/**/*.json.
// Do not hand-edit; change a translation file and re-run the build.

export const I18N_VERSION = 'd48da07ec8';
